/********************************************************************
 * Copyright (c) Certus Software, 2022.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, Input, OnInit} from '@angular/core';
import {fadeInOutAnimation} from '../../_animations/animations';
import {Downloads} from '../../_models/downloads';
import {environment} from 'src/environments/environment';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {UserService} from '../../_services/user.service';
import {SpinnerServiceService} from '../../_services/spinner-service.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'product-download-section',
  templateUrl: './product-download-section.component.html',
  styleUrls: ['./product-download-section.component.scss'],
  animations: [
    fadeInOutAnimation
  ]
})
export class ProductDownloadSectionComponent implements OnInit {

  downloadsDetails: Downloads = null;
  softwareChoiceIso = false;
  softwareChoiceIos = false;
  softwareChoiceCut = false;
  softwareChoiceApk = false;
  cutDownloadDetails: any;
  env = environment;
  @Input() showSoftwareChoiceCecedeOnly: boolean;
  @Input() showSoftwareChoiceIso: boolean;
  @Input() showSoftwareChoiceIos: boolean;
  @Input() showSoftwareChoiceCut: boolean;
  @Input() showSoftwareChoiceApk: boolean;
  @Input() cardTitle: string;
  @Input() hideLinuxCecede: boolean;
  @Input() hideMacosCecede: boolean;
  @Input() cardsLayout: string;

  constructor(
    private userService: UserService,
    private spinner: SpinnerServiceService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.spinner.stop();
    /*
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userService.setCutDownloadDetails().subscribe(data => {
        this.cutDownloadDetails = data;
      });
    });
    this.userService.setCurrentSoftwareDownloadDetails().subscribe(data => {
      this.downloadsDetails = data;
    });
    this.userService.setCutDownloadDetails().subscribe(data => {
      this.cutDownloadDetails = data;
    });
     */
  }
}
